import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetProfitability = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()

  const initialFilters = {
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
  }

  const {filters, onDateChange} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/report-summary', {
    queryId: 'profitability-summary',
    filters: filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  return {
    profitabilitySummaryData: response?.data || [],
    onDateChangeProfitabilitySummary: onDateChange,
    isLoading: isFetching,
  }
}

export default useGetProfitability
